<template>
  <div class="productfeature">
    <ul>
      <li v-for="(item,index) in data" :key="index"><span>＞</span>{{ item }}</li>

    </ul>
  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      //   content: [
      //     "保费低，政府补贴高。每亩保费仅需17.5元-32元，您仅需缴纳3.5元-6.4元",
      //     "保障范围广，基本涵盖各种灾害",
      //     "保障茶叶作物种植成本，不保作物产量和收益赔付",
      //     "标准清晰，赔付流程专业，赔付结果公开",
      //   ],
    };
  },
  computed: {},
  created() {
    // console.log('test',this.data);
  },
  methods: {},
  mounted() {},
};
</script>

<style lang='scss' scoped >
.productfeature {
  //   margin-top: 30px;
  width: 94%;
  margin: 0 auto;
  // height: 100%;
  box-sizing: border-box;
  ul li {
    height: 30px;
    line-height: 30px;
    span {
      color: #41d87f;
    }
  }
}
</style>
